import { render, staticRenderFns } from "./MunicipalityDetail.vue?vue&type=template&id=747cd09d&scoped=true&"
import script from "./MunicipalityDetail.vue?vue&type=script&lang=js&"
export * from "./MunicipalityDetail.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalityDetail.vue?vue&type=style&index=0&id=747cd09d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747cd09d",
  null
  
)

export default component.exports